import { BiDotsVerticalRounded } from 'react-icons/bi'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { useEffect, useRef, useState } from 'react'

const TableSettingMenu = ({ children, tooltipContent = 'Columns Menu' }: any) => {
    const [isOpen, setIsOpen] = useState(false)
    const menuRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    const toggleMenu = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <Tooltip id="setting-menu" place="top" />
            <div ref={menuRef} style={{ position: 'relative', display: 'inline-block' }}>
                <button
                    type='button'
                    className='btn btn-sm pe-0 py-0'
                    onClick={toggleMenu}
                >
                    <BiDotsVerticalRounded
                        data-tooltip-id={tooltipContent ? "setting-menu" : undefined}
                        data-tooltip-content={tooltipContent || undefined}
                    />
                </button>
                {isOpen && (
                    <div
                        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 w-300px w-md-325px text-start'
                        style={{
                            position: 'absolute',
                            top: '100%',
                            right: '0',
                            zIndex: 99999,
                            maxHeight: '400px',
                            overflow: 'auto',
                            display: 'block',
                        }}
                    >
                        <div className='px-7 py-5'>
                            <div className='fs-5 text-gray-800 fw-bold'>Display Menu</div>
                        </div>

                        <div className='separator border-gray-200'></div>

                        <div className='px-7 py-5' data-kt-user-table-filter='form'>
                            <div className='overflow-auto sm-scroll mh-350px'>
                                {children}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default TableSettingMenu